module.exports = __webpack_public_path__ + "img/transparent-success-icon.70fd9ec9.png";